import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import api from "./api";
import {handleResponseStatus, updateIdField, updateItem} from "./utils";

const initialState = {
    items: [],
    createStatus: "success", // 'idle' | 'loading' | 'success' | 'failed'
    fetchStatus: "success", // 'idle' | 'loading' | 'success' | 'failed'
    fetchByIdStatus: "idle", // 'idle' | 'loading' | 'success' | 'failed',
    updateStatus: "idle", // 'idle' | 'loading' | 'success' | 'failed'
    deleteStatus: "idle", // 'idle' | 'loading' | 'success' | 'failed'
    pagination: {},
    error: null
};


export const fetchAllExpenseProducts = createAsyncThunk('product/fetchAllExpenseProducts', async ({
                                                                                                      scope,
                                                                                                      scopeId,
                                                                                                      roleSign,
                                                                                                      expenseTypeId,
                                                                                                      page,
                                                                                                      limit,
                                                                                                  } = {}) => {
    try {
        let response;
        const params = new URLSearchParams();
        if (page) params.append("page", page);
        if (limit) params.append("limit", limit);

        const queryString = params.toString();
        const fullParams = queryString ? `&${queryString}` : '';
        response = await api.get(`/${roleSign}/restaurentProductTemplate?ttid=${expenseTypeId}${fullParams}`);

        return {...response};
    } catch (error) {
        if (error.response) return error.response;
        throw error;
    }
});

export const createExpenseProduct = createAsyncThunk('product/createExpenseProduct', async ({
                                                                                                roleSign,
                                                                                                scopeId,
                                                                                                data
                                                                                            }) => {
    try {
        const response = await api.post(`${roleSign}/restaurentProductTemplate/addNewProduct`, data);
        return {...response};
    } catch (error) {
        if (error.response) return error.response;
        throw error;
    }
});

export const updateExpenseProducts = createAsyncThunk('product/updateExpenseProducts', async ({
                                                                                                  scope,
                                                                                                  roleSign,
                                                                                                  data,
                                                                                                  id
                                                                                              }) => {
    try {
        let response = await api.patch(`/${roleSign}/restaurentProductTemplate/${id}`, data);
        return {...response};
    } catch (error) {
        if (error.response) return error.response;
        throw error;
    }
});

export const fetchExpenseProductById = createAsyncThunk('product/fetchExpenseProductById', async ({
                                                                                                      scope,
                                                                                                      roleSign,
                                                                                                      id
                                                                                                  }) => {
    try {
        let response = await api.get(`/${roleSign}/restaurentProductTemplate/${id}`);
        return {...response};
    } catch (error) {
        if (error.response) return error.response;
        throw error;
    }
});

const expenseProductSlice = createSlice({
    name: "expenseProduct",
    initialState,
    reducers: {
        resetCreateStatus(state) {
            state.createStatus = 'idle';
        },
        resetUpdateStatus(state) {
            state.updateStatus = 'idle';
        },
        resetDeleteStatus(state) {
            state.deleteStatus = 'idle';
        },
    },
    extraReducers: (builder) => {
        builder

            //create Expense product
            .addCase(createExpenseProduct.pending, (state) => {
                state.createStatus = 'loading';
            })
            .addCase(createExpenseProduct.fulfilled, (state, action) => {
                const {createStatus, error} = handleResponseStatus(action.payload, 'createStatus');
                state.createStatus = createStatus;
                state.error = error;
            })
            .addCase(createExpenseProduct.rejected, (state, action) => {
                state.createStatus = 'failed';
                state.error = action.error.message;
            })


            // Fetch Expense Products
            .addCase(fetchAllExpenseProducts.pending, (state) => {
                state.fetchStatus = 'loading';
            })
            .addCase(fetchAllExpenseProducts.fulfilled, (state, action) => {
                const {fetchStatus, error} = handleResponseStatus(action.payload, 'fetchStatus');
                const {data, ...pagination} = action.payload.data;
                state.items = fetchStatus === "success" ? updateIdField(data) : state.items;
                state.fetchStatus = fetchStatus;
                state.pagination = pagination;
                state.error = error;
            })
            .addCase(fetchAllExpenseProducts.rejected, (state, action) => {
                state.fetchStatus = 'failed';
                state.error = action.error.message;
            })

            // Fetch Expense Product by ID
            .addCase(fetchExpenseProductById.pending, (state) => {
                state.fetchByIdStatus = 'loading';
            })
            .addCase(fetchExpenseProductById.fulfilled, (state, action) => {
                const {fetchByIdStatus, error} = handleResponseStatus(action.payload, 'fetchByIdStatus');
                state.items = fetchByIdStatus === "success" ? updateItem(action.payload.data.data, state.items) : state.items;
                state.fetchByIdStatus = fetchByIdStatus;
                state.error = error;
            })
            .addCase(fetchExpenseProductById.rejected, (state, action) => {
                state.fetchByIdStatus = 'failed';
                state.error = action.error.message;
            })

            // Update Expense Product
            .addCase(updateExpenseProducts.pending, (state) => {
                state.updateStatus = 'loading';
            })
            .addCase(updateExpenseProducts.fulfilled, (state, action) => {
                const {updateStatus, error} = handleResponseStatus(action.payload, 'updateStatus');
                state.updateStatus = updateStatus;
                state.error = error;
            })
            .addCase(updateExpenseProducts.rejected, (state, action) => {
                state.updateStatus = 'failed';
                state.error = action.error.message;
            })
    }
});

export const {
    resetCreateStatus,
    resetUpdateStatus,
    resetDeleteStatus,
} = expenseProductSlice.actions;
export default expenseProductSlice.reducer;
